import { render, staticRenderFns } from "./FavoriteButton.vue?vue&type=template&id=57413786&scoped=true"
import script from "./FavoriteButton.vue?vue&type=script&lang=js"
export * from "./FavoriteButton.vue?vue&type=script&lang=js"
import style0 from "./FavoriteButton.vue?vue&type=style&index=0&id=57413786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57413786",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/var/www/tubber-new/components/global/v/button.vue').default})
